// extracted by mini-css-extract-plugin
export default {"info-window":"Map_info-window__OLv2z"};